import { useSelector } from 'store';

export function useMerchantCampaigns() {
  return useSelector((state) => state.pages.merchantCampaigns);
}
